import store from "@root/store";

export function compose(...callbacks) {
  return function (options) {
    return callbacks.reduceRight(
      (sequence, fn) => sequence.then(response => fn(response)),
      Promise.resolve(options)
    );
  };
}

export function diff(state, prevState) {
  return Object.keys(state).reduce(
    (changeKeys, k) =>
      state[k] === prevState[k] ? changeKeys : [...changeKeys, k],
    []
  );
}

// console the state change
export function consoleDiff(props) {
  const { changeKeys, state, prevState } = props;

  changeKeys.forEach(key => {
    console.log(
      `MAIN APP TIPS: state.${key}的值由${prevState[key]}变为${state[key]}`
    );
  });

  return props;
}

// Sync qiankun global state to vuex global state
export function sync2Store(mutation) {
  return function (props) {
    const { changeKeys, state } = props;

    changeKeys.forEach(key => {
      store.commit(mutation, { key: key, value: state[key] });
    });

    return props;
  };
}
